import React from 'react';

var FocusGroupContext = /*#__PURE__*/React.createContext();

export default FocusGroupContext;
//# sourceMappingURL=FocusGroupContext.js.map
